import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowRight } from '@phosphor-icons/react';
import { Badge } from '@/components/ui/badge';
import { useT } from '@/i18n/LanguageContext';
import { fmtDate, PRIORITY_BADGE, dispText } from '../plannerConstants';

// B4 — 件数だけ全件で、一覧は先頭6件という切り捨てをやめる。
// カードはスクロールで全件たどれて、「すべて見る」で一覧画面へ出られる。
export default function AlertList({
  title, Icon, color, items = [], allHref, testid, cardTestId, countTestId,
  dueClass = 'text-zinc-500', note,
}) {
  const { t } = useT();
  const navigate = useNavigate();
  const location = useLocation();
  // そのタスクのドロワーまで開く。戻り先も持たせる（B5）。
  const openTask = (tk) => navigate(
    `/planner/project/${tk.project_id}?task=${tk.id}&from=${encodeURIComponent(location.pathname + location.search)}`);

  return (
    <div className="bg-white rounded-xl border border-zinc-200 shadow-sm p-4" data-testid={cardTestId || testid}>
      <div className="flex items-center gap-2 mb-3">
        <Icon size={18} weight="duotone" className={color} />
        <h3 className="text-sm font-bold text-zinc-800">{title}</h3>
        <span className="ml-auto text-xs text-zinc-400 tabular-nums"
          data-testid={countTestId || (testid ? `${testid}-count` : undefined)}>{items.length}</span>
      </div>
      {items.length === 0 ? (
        <p className="text-xs text-zinc-400 py-3 text-center">{t('planner.alerts.empty')}</p>
      ) : (
        <div className="space-y-1.5 max-h-64 overflow-y-auto pr-0.5" data-testid={testid ? `${testid}-list` : undefined}>
          {items.map((tk) => (
            <button key={tk.id} onClick={() => openTask(tk)} aria-label={tk.title}
              data-testid={`alert-task-${tk.id}`}
              className="w-full flex items-start gap-2 text-left rounded-lg px-2 py-1.5 hover:bg-zinc-50 transition-colors">
              <Badge variant="outline" className={`${PRIORITY_BADGE[tk.priority]} text-[10px] px-1.5 py-0 shrink-0 mt-0.5`}>
                {t(`planner.priority.${tk.priority}`)}
              </Badge>
              <div className="min-w-0 flex-1">
                <div className="flex items-baseline gap-2">
                  <span className="text-sm text-zinc-800 font-medium truncate flex-1"><span data-no-translate>{dispText(tk.title)}</span></span>
                  <span className={`text-[11px] font-medium tabular-nums shrink-0 ${tk.overdue ? 'text-rose-600' : dueClass}`}>
                    {fmtDate(tk.due_date)}
                  </span>
                </div>
                <span className="block text-[11px] text-zinc-400 truncate mt-0.5">
                  {tk.blocked && <span className="text-rose-600 font-medium mr-1">{t('planner.taskStatus.blocked')}</span>}
                  <span data-no-translate>{dispText(tk.project_name)}</span>
                  {/* 完了した案件に残った未完了タスクは、そうと分かるようにしておく */}
                  {tk.project_finished && (
                    <span className="ml-1 rounded bg-zinc-100 px-1 py-px text-[10px] text-zinc-500"
                      data-testid={`alert-task-finished-${tk.id}`}>{t('planner.project.finishedTag')}</span>
                  )}
                </span>
              </div>
            </button>
          ))}
        </div>
      )}
      {note && <p className="mt-2 text-[11px] text-zinc-500" data-testid={testid ? `${testid}-note` : undefined}>{note}</p>}
      {allHref && (
        <button type="button" onClick={() => navigate(allHref)}
          data-testid={testid ? `${testid}-all` : undefined}
          className="mt-2 inline-flex items-center gap-1 text-[11px] font-semibold text-indigo-600 hover:text-indigo-700">
          {t('planner.alerts.seeAll')} <ArrowRight size={11} />
        </button>
      )}
    </div>
  );
}
